import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingPane } from '@social-solutions/ssg-forms';
import { ssgFormsAdapters } from '../common';
import { Title } from '../layout';
import * as authActions from '../auth/auth.actions';
import './acct.scss';
import * as demographicsActions from '../demographics/demographics.actions';
import { DemographicsComponent } from '../demographics';
import { ChangeEmailComponent } from './email';
import { ChangePasswordComponent } from './password';
import { UserPreferencesComponent } from './preferences';

export class AccountInfoComponent extends Component {
  componentWillMount() {
    const { demographicsActions } = this.props;

    demographicsActions.getSettings();
  }

  render() {
    const { demographics } = this.props;
    const { settingsState } = demographics;
    const { data : settings } = settingsState || { data : null };
    const { demographicsEnabled } = settings || { demographicsEnabled : false };

    return (
    <div className="acct">
      <Title title="Account Information"/>
      <h1 className="ssg-forms-text xl title">Account Information</h1>
      <LoadingPane
        loadingState={ssgFormsAdapters.convertLoadingState(settingsState)}
        loadingMessage={"Loading Account Information..."}>
        <div className="account-widget-group">
          <div className="account-actions account-flex-item">
            <ChangeEmailComponent />
            <ChangePasswordComponent />
            <UserPreferencesComponent />
          </div>
          {demographicsEnabled ? (
            <div className="account-flex-item account-demographics">
              <DemographicsComponent />
            </div>
          ) : null}
        </div>
      </LoadingPane>
    </div>
    )
  };

}

AccountInfoComponent.propTypes = {
  auth: PropTypes.any.isRequired,
  accountInfo: PropTypes.any.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    demographicsActions: bindActionCreators(demographicsActions, dispatch),

  }
}

const mapStateToProps = ({ routing, auth, accountInfo, demographics }) => {
  return {
    auth,
    routing,
    accountInfo,
    demographics,
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AccountInfoComponent);





// WEBPACK FOOTER //
// src/acct/account-info.component.js